import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, ExternalLink, Star } from 'lucide-react';
import { toast } from 'sonner';
import { PageHeader } from '../PageHeader';
import { appLinks } from '../data';
const categories = ['All', ...Array.from(new Set(appLinks.map(a => a.category).filter(Boolean) as string[]))];
export function AppsPage() {
  const [query, setQuery] = useState('');
  const [cat, setCat] = useState('All');
  const [favs, setFavs] = useState<Record<string, boolean>>({
    Velocify: true
  });
  const filtered = appLinks.filter(a => {
    const matchesQuery = a.label.toLowerCase().includes(query.toLowerCase());
    const matchesCat = cat === 'All' || a.category === cat;
    return matchesQuery && matchesCat;
  });
  return <>
      <PageHeader title="Apps" subtitle="Single sign-on access to every tool you use." data-id="element-400" data-mp="3n4n21blapeuu" />

      <div className="flex flex-col sm:flex-row gap-3 mb-6" data-id="element-401" data-mp="3j438ehzxktdg">
        <div className="relative flex-1 max-w-md" data-id="element-402" data-mp="3j1h0gh94obup">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-navy-400" data-id="element-403" data-mp="91aqf7t3hdy5" />
          <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Search apps…" className="w-full pl-11 pr-4 py-2.5 rounded-full bg-white border border-navy-100 focus:border-gold-400 focus:outline-none focus:ring-2 focus:ring-gold-400/30 text-sm text-navy-900" data-id="element-404" data-mp="e0di7qk2dno6" />
        </div>
        <div className="flex flex-wrap gap-2" data-id="element-405" data-mp="3mb897slqy99y">
          {categories.map(c => <button key={c} onClick={() => setCat(c)} className={`px-3.5 py-1.5 rounded-full text-sm font-semibold transition-colors ${cat === c ? 'bg-navy-600 text-white' : 'bg-white text-navy-600 border border-navy-100 hover:border-gold-400'}`} data-id="element-406" data-mp="3ra1gh3afx41o">
              {c}
            </button>)}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-407" data-mp="1gecfphmzxxtu">
        {filtered.map((app, i) => <motion.div key={app.label} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: i * 0.03
      }} className="relative bg-white rounded-xl border border-navy-100 hover:shadow-md hover:border-gold-400 transition-all group" data-id="element-408" data-mp="3cl50nwfjx0il" data-mpi={i}>
            <button onClick={() => setFavs(f => ({
          ...f,
          [app.label]: !f[app.label]
        }))} className="absolute top-3 right-3 z-10 text-navy-300 hover:text-gold-500" aria-label={`Favorite ${app.label}`} data-id="element-409" data-mp="2otzk1f1se478">
              <Star className={`w-4 h-4 ${favs[app.label] ? 'fill-gold-500 text-gold-500' : ''}`} data-id="element-410" data-mp="2a30g4hbwc3tz" />
            </button>
            {app.url ? <a href={app.url} target="_blank" rel="noopener noreferrer" className="block p-5 focus:outline-none focus:ring-2 focus:ring-gold-400/40 rounded-xl" aria-label={`Launch ${app.label}`} data-id="element-411" data-mp="1vy02qj9xlh3i">
                <span className={`w-14 h-14 rounded-xl ${app.color} text-white font-bold flex items-center justify-center mb-3 group-hover:scale-105 transition-transform`} data-id="element-412" data-mp="1qz58ml6ik643">
                  {app.initials}
                </span>
                <p className="font-bold text-navy-900" data-id="element-413" data-mp="24rd3u8i5fp0o">{app.label}</p>
                <p className="text-xs text-navy-400 mb-3" data-id="element-414" data-mp="24r3f0o8ubnwk">{app.description}</p>
                <span className="inline-flex items-center gap-1 text-xs font-bold text-gold-600" data-id="element-415" data-mp="29p4uz0ayz73t">
                  Launch <ExternalLink className="w-3 h-3" data-id="element-416" data-mp="tamuigifih2u" />
                </span>
              </a> : <button type="button" onClick={() => toast(`${app.label} opens once single sign-on is connected.`)} className="block w-full text-left p-5 focus:outline-none focus:ring-2 focus:ring-gold-400/40 rounded-xl" data-id="element-417" data-mp="yckmbz4wak7e">
                <span className={`w-14 h-14 rounded-xl ${app.color} text-white font-bold flex items-center justify-center mb-3 group-hover:scale-105 transition-transform`} data-id="element-418" data-mp="14q9lho93996e">
                  {app.initials}
                </span>
                <p className="font-bold text-navy-900" data-id="element-419" data-mp="1sjhyr8iigwvg">{app.label}</p>
                <p className="text-xs text-navy-400 mb-3" data-id="element-420" data-mp="1niau3ibo0dt0">{app.description}</p>
                <span className="inline-flex items-center gap-1 text-xs font-bold text-gold-600" data-id="element-421" data-mp="1ik9bszm2ciil">
                  Launch <ExternalLink className="w-3 h-3" data-id="element-422" data-mp="c3oz727gzn9p" />
                </span>
              </button>}
          </motion.div>)}
      </div>
    </>;
}